import { getVariantFromId } from '@shopify/theme-product';
import { getUrlWithVariant } from '@shopify/theme-product-form';
import { useMount, useUpdateEffect } from 'ahooks';
import classNames from 'classnames';
import React, { useReducer } from 'react';
import { variantsReducer } from './variantsReducer';

const VariantSelector = ({ product, handleVariantSelection }) => {
  const [state, dispatch] = useReducer(variantsReducer, { variants: [], answers: [], options: {} });

  /**
   * Initialize the reducer
   */
  useMount(() => {
    dispatch({ type: 'INIT', variants: product.variants, options: product.options });
  });

  /**
   * Look for variant ID in the URL and select it
   * If only a single variant is available, select it
   */
  useMount(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantID = urlParams.get('variant');
    if (variantID) {
      let preloadVariant = getVariantFromId(product, Number(variantID));
      dispatch({ type: 'SELECT_VARIANT', variant: preloadVariant });
    } else {
      if (product.variants.length === 1) {
        dispatch({ type: 'SELECT_VARIANT', variant: product.variants[0] });
      }
    }
  });

  const handleChange = (option) => (value) => {
    dispatch({ type: 'UPDATE_OPTION', option, value });
  };

  useUpdateEffect(() => {
    if (state.winning_variant) {
      handleVariantSelection(state.winning_variant);
      const url = getUrlWithVariant(window.location.href, state.winning_variant.id);
      window.history.replaceState({ path: url }, '', url);
      window.theme_app.emit('variant_selected', { variant: state.winning_variant });
    } else {
      handleVariantSelection(null);
    }
  }, [state.winning_variant]);

  const isOptionAvailable = (option, value) => {
    return state.available_options ? state.available_options[`option${option.position}`].includes(value) : false;
  };

  return (
    <div className="variant-selector">
      <div className="variant-filters">
        {product.options.map((option, index) => (
          <div key={`option-${option.name}-${index}`} className="variant-filters_option">
            <label>{option.name}</label>
            <div className="option-values">
              {option.values.map((value, index) => {
                let optionClasses = classNames('Button variant-swatch', {
                  'is-selected': state.answers[`option${option.position}`] === value,
                  'is-unavailable': !isOptionAvailable(option, value),
                });
                return (
                  <button
                    type="button"
                    className={optionClasses}
                    onClick={() => handleChange(`option${option.position}`)(value)}
                    key={`${option.name}-${value}`}
                  >
                    {value}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VariantSelector;
